import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    position: relative;
    height: 40px;
    cursor: pointer;
}
`;

export const Label = styled.span`
    margin-left: 30px;
    font-weight: 400;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
}
`;

export const Color = styled.div`
   width: 10px;
   height: 10px;
   border-radius: 10px;
   background-color: ${(props) => (props.color ? props.color : '#393837')};
   top: 50%;
   transform: translateY(-50%);
   position: absolute;
   margin-left: 5px;
}
`;
